export const environment = {
    production: false,
    dev: true,
    NmdpConfig: {
        authority: window["env"]["oidc_authority"],
        clientId: window["env"]["oidc_client_id"],
        scope: window["env"]["okta_scopes"],
        responseType: 'code',
        useRefreshToken: true
    },
    ehr_redirect_url: window["env"]["ehr_redirect_url"],
    ehr_client_id: window["env"]["ehr_client_id"],
    cibmtr_fhir_r3_url: window["env"]["cibmtr_fhir_r3_url"],
    cibmtr_fhir_r4_url: window["env"]["cibmtr_fhir_r4_url"],
    lab_loinc_codes: [window["env"]["lab_loinc_codes"]],
    logica_client_ids: [window["env"]["logica_client_ids"]],
    logica_ehrs: [window["env"]["logica_ehrs"]],
    vs_loinc_codes: [window["env"]["vs_loinc_codes"]],
    cra_version: window["env"]["cra_version"],
    ms_version: window["env"]["ms_version"],
    pi_api_url: window["env"]["pi_api_url"]
};
